import React, { useRef } from "react";
import { useAutoFitText } from "@/lib/useAutoFitText";

// Centered text whose size adapts to the space actually available (see useAutoFitText).
// Fixed frames (stories): the wrapper fills its parent and fits the box height.
// Growing cards (feed): pass `targetHeight` — the text shrinks until that height, then
// (very long texts) stays at the readable minimum and the card grows instead of clipping.
// Fixed-frame mode fills the positioned parent (absolute inset-0) — a percentage height
// inside a grid/flex parent would otherwise grow with the text and defeat the measure.
export const AutoFitText = ({ text, scale = 1, minPx = 14, maxRatio = 0.14, maxPx = 64, targetHeight, className = "", boxClassName = "", style, testId, refitKey, render }) => {
  const boxRef = useRef(null);
  const textRef = useRef(null);
  useAutoFitText({ boxRef, textRef, text, scale, minPx, maxRatio, maxPx, targetHeight, refitKey });
  return (
    <div ref={boxRef} className={`${targetHeight ? "relative w-full" : "absolute inset-0"} grid place-items-center ${boxClassName}`} data-testid={testId}>
      <p ref={textRef} className={`whitespace-pre-wrap break-words text-center w-full ${className}`} style={{ lineHeight: 1.3, ...style }}>
        {render ? render(text) : text}
      </p>
    </div>
  );
};
